<template>
    <div id="main">
        <loader v-if="isLoading" />
        <div class="page page-container">
            <!-- CONTAINER DE ALERTAS -->
            <alert-container :messages="msgs" />

            <div class="vertical-flow">
                <div class="listing-header">
                    <div class="title-breadcrumb">
                        <h1 class="title">
                            {{ $t("nova-situacao-cliente") }}
                        </h1>
                        <nav class="breadcrumb" aria-label="breadcrumbs">
                            <ul>
                                <li>
                                    <a class="a-inativo">{{
                                        isVenda ? $t("vendas") :
                                        $t("agro")
                                    }}</a>
                                </li>
                                <li>
                                    <a
                                        @click="
                                            $router.push({
                                                name: `${abrev}-situacao`,
                                            })
                                        "
                                        >{{ $t("situacao-cliente") }}</a
                                    >
                                </li>
                                <li>
                                    <a aria-current="page">{{
                                        $route.params.id
                                            ? $route.params.id
                                            : $t("novo")
                                    }}</a>
                                </li>
                            </ul>
                        </nav>
                    </div>
                    <div class="header-buttons">
                    <button
                        class="delete-btn"
                        type="button"
                        @click="
                            $router.push({
                                name: `${abrev}-situacao-list`,
                            })
                        "
                    >
                        {{ $t("voltar") }}
                    </button>
                        <button
                            v-if="
                                (!integracao &&
                                    !isUpdate &&
                                    permissao.create) ||
                                (!integracao && isUpdate && permissao.update)
                            "
                            class="save-btn"
                            type="button"
                            @click="save"
                            :disabled="isSaving"
                        >
                            {{ $t("salvar") }}
                            <button-loader :isSaving="isSaving" />
                        </button>
                    </div>
                </div>
                <br />
                <div class="form-columns-fit">
                    <div class="columns is-flex-wrap">
                        <div class="column is-3">
                            <v-input
                                :id="generateId(1)"
                                ref="idErpInput"
                                v-model="situacaocliente.idsituacaoerp"
                                placeholder="placeholder-preencha"
                                :maxlength="30"
                                title="codigo"
                                uppercase
                                required
                                :invalid="!situacaocliente.idsituacaoerp"
                                tooltipLabel="cod-ref"
                            />
                        </div>
                        <div class="column is-9">
                            <v-input
                                :id="generateId(2)"
                                ref="descricaoInput"
                                v-model="situacaocliente.descricao"
                                placeholder="placeholder-preencha"
                                :maxlength="30"
                                title="descricao"
                                msg="msg-campo-obrigatorio"
                                :invalid="!situacaocliente.descricao"
                                uppercase
                                required
                                tooltipLabel="info-descricao-situacao-cadastral"
                            />
                        </div>
                        <div class="column is-4">
                            <vss-select
                                title="liberapedido"
                                :id="generateId(3)"
                                ref="liberapedidoSelect"
                                :options="liberapedidoSelect"
                                v-model="liberapedidoSelected"
                                :mlLabels="true"
                                required
                                @onBlurFunction="sendIsChanged()"
                                tooltipLabel="info-libera-pedido-situacao-cadastral"
                            />
                        </div>
                        <!-- @86372 - esse campo era pra ser um select, será criado um novo chamado para alterar -->
                        <!-- <div class="column is-6">
                            <v-input
                                :id="generateId(5)"
                                ref="finalidadeInput"
                                v-model="situacaocliente.finalidade"
                                placeholder="placeholder-preencha"
                                :maxlength="50"
                                title="finalidade"
                                :invalid="!situacaocliente.finalidade"
                                required
                            />
                        </div> -->
                        <div class="column is-4">
                            <color-picker
                                :id="generateId(5)"
                                type="text"
                                :color="situacaocliente.cor"
                                ref="cpInput"
                                :required="true"
                                @colorpicked="colorpicked"
                                tooltipLabel="info-cor-situacao-cadastral"
                                title="selecione-uma-cor"
                            />
                        </div>
                        <div class="column is-4">
                            <vss-select
                                title="situacao"
                                :id="generateId(9)"
                                ref="situacaoSelect"
                                :searchable="false"
                                :options="situacoes"
                                v-model="situacao"
                                class="no-clear"
                                :mlLabels="true"
                                :disabled="!isUpdate"
                                @onBlurFunction="sendIsChanged()"
                                tooltipLabel="info-situacao-generica"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import SituacaoService from "@/services/SituacaoService";
import SituacaoValidation from "@/services/validations/vendas/SituacaoValidation";
import Message from "@/models/Message";
import HideInfo from "@/components/shared/HideInfo";
import ColorPicker from "@/components/shared/form/ColorPicker";

export default {
    beforeRouteLeave(to, from, next) {
        if (this.isChanged) {
            this.promptChangeTab(next);
        } else {
            next();
        }
    },
    components: {
        HideInfo,
        ColorPicker,
    },
    data() {
        return {
            integracao:
                this.$store.state.user.tabelasERPWebServer.includes("SITUACAO"),
            service: new SituacaoService(this.$http, this.$router),
            isLoading: false,
            msgs: [],
            isSaving: false,
            validation: new SituacaoValidation(this.$root.msgs),
            situacaocliente: {
                id: null,
                idsituacaoerp: null,
                idempresa: null,
                descricao: null,
                cor: "#000000",
                liberapedido: null,
                finalidade: null,
                situacao: null,
            },
            isUpdate: false,
            situacoes: [
                { label: "inativo", id: 0 },
                { label: "ativo", id: 1 },
            ],
            liberapedidoSelect: [
                { label: "nao", id: "N" },
                { label: "sim", id: "S" },
            ],
            liberapedidoSelected: { label: "sim", id: "S" },
            situacao: { label: "ativo", id: 1 },
            isChanged: false,
            isLoadingEdit: false,

            //permissoes relativas à exibição dos botões
            permissao: false,
            permissaoVincular: false,

            // @86308 - Rota dinâmica abreviando o contexto
            abrev: this.$route.meta.contexto.slice(0,3),
            isVenda: this.$route.meta.contexto == "vendas",
            isAgro: this.$route.meta.contexto == "agro",
        };
    },
    created() {
        this.isChanged = false;
        if (this.$route.params.id) this.isUpdate = true;

        if (this.isVenda) {
            this.permissao = this.hasPermissionAccess(
                "vendas",
                "clientes",
                "ven-situacao"
            );
        }else if (this.isAgro){
            this.abrev = this.$route.meta.contexto.slice(0,4);
            this.permissao = this.hasPermissionAccess( 
                'agro', 
                'clientes', 
                'agro-situacao'
            );
        }

        this.permissaoVincular =
            this.permissao.create && !this.assClienteTransportadoraIntegracao;
        if (!this.isUpdate && !this.permissao.create) {
            this.$router.push({
                name: "acesso-nao-permitido",
                params: { tela: "situacao-cliente" },
            });
        } else {
            if (this.isUpdate) this.carregarDados();
        }
        this.isLoadingEdit = true;
    },
    watch: {
        situacaocliente: {
            deep: true,
            handler: function () {
                if (!this.isLoadingEdit) {
                    this.isChanged = true;
                } else if (!this.isUpdate) {
                    this.isLoadingEdit = false;
                }
            },
        },
    },
    methods: {
        promptChangeTab(next) {
            this.$root.confirm({
                message: this.$t("msg-tem-certeza-alteracoes"),
                onConfirm: (_) => {
                    this.isChanged = false;
                    next();
                },
                onCancel: (_) => {
                    next(false);
                },
            });
        },
        colorpicked(color) {
            this.situacaocliente.cor = color;
        },
        generateId(numberId) {
            return this.$route.name + "-" + numberId;
        },
        sendIsChanged(){
            if (!this.isLoadingEdit && !this.isLoading){
                this.isChanged = true;
            }else {
                this.isChanged = false;
            }
        },
        carregarDados() {
            this.isLoading = true;
            this.isLoadingEdit = true;
            this.findSituacaoById()
                .then((value) => {
                    this.situacaocliente = value.content;
                    this.situacaocliente.cor = this.situacaocliente.cor.replace('#', '');
                    this.situacaocliente.cor = '#' + (this.situacaocliente.cor || '00000');

                    this.situacao =
                        this.situacoes[this.situacaocliente.situacao];
                    this.liberapedidoSelected = this.liberapedidoSelect
                        .filter(selected => selected.id == value.content.liberapedido)[0];
                })
                .catch((e) => {
                    console.error(e);
                    this.msgs.push(new Message("error", "msg-erro-load", true));
                })
                .finally((_) => {
                    this.isChanged = false;
                    this.isLoading = false;
                    this.isLoadingEdit = false;
                });
        },
        findSituacaoById(){
            if(this.isVenda) return this.service.findVendas(this.$route.params.id);
            else return this.service.findAgro(this.$route.params.id);
        },
        save() {
            if (this.validation.validate(this.situacaocliente, this.$refs)) {
                let situacaoTemp = Object.assign({}, this.situacaocliente);
                /**
                 * @86372 - por hora o campo finalidade era pra ser um select, alterar aqui
                 * quando mudar esse campo
                 */
                situacaoTemp.finalidade = '';
                situacaoTemp = this.mapTosave(situacaoTemp);
                situacaoTemp.situacao = this.situacao.id;
                situacaoTemp.liberapedido = this.liberapedidoSelected.id;
                //remover o caracter # para salvar no banco
                situacaoTemp.cor = situacaoTemp.cor.replace('#', '');
                this.isSaving = true;
                this.service
                    .save(situacaoTemp)
                    .then((value) => {
                        let msg = "msg-save-situacao";

                        if (value.status == 200){
                            if (this.situacaocliente.id != null) {
                                msg = "msg-edit-situacao";
                            }
                            this.isChanged = false;
                            this.msgs.push(new Message("success", msg, true));
                            
                            this.redirectToPage();
                        } else {
                            this.isChanged = false;
                            this.msgs.push(new Message("success", msg, true));
                            
                            this.redirectToPage();
                        }
                    })
                    .catch((e) => {
                        if (this.$te(e.message)) {
                            if (e.message == "msg-codigo-duplicado-n") {
                                this.msgs.push(
                                    new Message(
                                        "alert", 
                                        this.$t(e.message, { n: situacaoTemp.idsituacaoerp }), 
                                        true, 
                                        false
                                    )
                                );
                            } else {
                                this.msgs.push(
                                    new Message("alert", e.message, true)
                                );
                            }
                        } else {
                            this.msgs.push(
                                new Message(
                                    "error",
                                    "msg-problema-realizar-acao",
                                    true
                                )
                            );
                        }
                    })
                    .finally(() => {
                        this.isSaving = false;
                        this.isLoading = false;
                        this.isLoadingEdit = false;
                    });
            } else {
                this.$root.showMessage(
                    "alert",
                    "msg-campos-obrigatorios",
                    true
                );
                this.isLoading = false;
                this.isLoadingEdit = false;
            }
        },
        redirectToPage() {
            setTimeout(
                () => {
                    this.$router.push({
                        name: `${this.abrev}-situacao-list`,
                    });
                },
                1000
            );
        },
    },
};
</script>
<style lang="scss" scoped>
#main {
    padding: 0 20px;
    height: auto;

    .page {
        position: relative;
    }
    #color {
        padding: 0 !important;
        height: 36px;
        cursor: pointer;
    }
}
</style>
